import { render } from "./Size.vue?vue&type=template&id=65d69772"
import script from "./Size.vue?vue&type=script&lang=ts"
export * from "./Size.vue?vue&type=script&lang=ts"
script.render = render

export default script